export const assetTypes = {
    FETCH_REQUEST: "ASSET_FETCH_REQUEST",
    FETCH_SUCCESS: "ASSET_FETCH_SUCCESS",
    FETCH_FAILURE: "ASSET_FETCH_FAILURE",
    FETCH_DEVICE_TYPES_REQUEST: "ASSET_FETCH_DEVICE_TYPES_REQUEST",
    FETCH_SINGLE_DEVICE_TYPES_REQUEST: "ASSET_FETCH_SINGLE_DEVICE_TYPES_REQUEST",
    FETCH_LOCATION_ALERTS_REQUEST: "ASSET_FETCH_LOCATION_ALERTS_REQUEST",
    FETCH_LOCATION_ALERTS_RESPONSE: "ASSET_FETCH_LOCATION_ALERTS_RESPONSE",
    FETCH_DEVICE_TYPES_SUCCESS: "ASSET_FETCH_DEVICE_TYPES_SUCCESS",
    FETCH_DEVICE_TYPES_FAILURE: "ASSET_FETCH_DEVICE_TYPES_FAILURE",
    FETCH_SINGLE_DEVICE_TYPES_SUCCESS: "ASSET_FETCH_SINGLE_DEVICE_TYPES_SUCCESS",
    FETCH_SINGLE_DEVICE_TYPES_FAILURE: "ASSET_FETCH_SINGLE_DEVICE_TYPES_FAILURE",
    FETCH_DEVICE_NAMES_REQUEST: "ASSET_FETCH_DEVICE_NAMES_REQUEST",
    FETCH_DEVICE_NAMES_SUCCESS: "ASSET_FETCH_DEVICE_NAMES_SUCCESS",
    FETCH_DEVICE_NAMES_FAILURE: "ASSET_FETCH_DEVICE_NAMES_FAILURE",
    FETCH_DEVICE_PROFILES_REQUEST: "ASSET_FETCH_DEVICE_PROFILES_REQUEST",
    FETCH_DEVICE_PROFILES_SUCCESS: "ASSET_FETCH_DEVICE_PROFILES_SUCCESS",
    FETCH_DEVICE_PROFILES_FAILURE: "ASSET_FETCH_DEVICE_PROFILES_FAILURE",
    FETCH_LOCATIONS_REQUEST: "ASSET_FETCH_LOCATIONS_REQUEST",
    FETCH_LOCATIONS_SUCCESS: "ASSET_FETCH_LOCATIONS_SUCCESS",
    FETCH_LOCATIONS_FAILURE: "ASSET_FETCH_LOCATIONS_FAILURE",
    FETCH_DEVICE_COUNT_FROM_GATEWAY_REQUEST: "ASSET_FETCH_DEVICE_COUNT_FROM_GATEWAY_REQUEST",
    FETCH_DEVICE_COUNT_FROM_GATEWAY_SUCCESS: "ASSET_FETCH_DEVICE_COUNT_FROM_GATEWAY_SUCCESS",
    FETCH_DEVICE_COUNT_FROM_GATEWAY_FAILURE: "ASSET_FETCH_DEVICE_COUNT_FROM_GATEWAY_FAILURE",
    UPDATE_FILTERS: "ASSET_UPDATE_FILTERS",
    CLEAR_FILTER: "ASSET_CLEAR_FILTER",
    UPDATE_PAGE_NO: "ASSET_UPDATE_PAGE_NO",
    UPDATE_UI: "ASSET_UPDATE_UI",
    CREATE_REQUEST: "ASSET_CREATE_REQUEST",
    CREATE_SUCCESS: "ASSET_CREATE_SUCCESS",
    CREATE_FAILURE: "ASSET_CREATE_FAILURE",
    UPDATE_REQUEST: "ASSET_UPDATE_REQUEST",
    UPDATE_SUCCESS: "ASSET_UPDATE_SUCCESS",
    UPDATE_FAILURE: "ASSET_UPDATE_FAILURE",
    DELETE_REQUEST: "ASSET_DELETE_REQUEST",
    DELETE_SUCCESS: "ASSET_DELETE_SUCCESS",
    DELETE_FAILURE: "ASSET_DELETE_FAILURE",
    DOWNLOAD_REQUEST: "ASSET_DOWNLOAD_REQUEST",
    DOWNLOAD_SUCCESS: "ASSET_DOWNLOAD_SUCCESS",
    DOWNLOAD_FAILURE: "ASSET_DOWNLOAD_FAILURE",
    DOWNLOAD_IMAGE_REQUEST: "ASSET_DOWNLOAD_IMAGE_REQUEST",
    DOWNLOAD_IMAGE_SUCCESS: "ASSET_DOWNLOAD_IMAGE_SUCCESS",
    DOWNLOAD_IMAGE_FAILURE: "ASSET_DOWNLOAD_IMAGE_FAILURE",
    FETCH_ALL_ASSETS_FOR_MAP_SUCCESS: "FASSET_ETCH_ALL_ASSETS_FOR_MAP_SUCCESS",
    FETCH_DEVICE_DETAILS_REQUEST: "ASSET_FETCH_DEVICE_DETAILS_REQUEST",
    FETCH_DEVICE_DETAILS_SUCCESS: "ASSET_FETCH_DEVICE_DETAILS_SUCCESS",
    FETCH_DEVICE_DETAILS_FAILURE: "ASSET_FETCH_DEVICE_DETAILS_FAILURE",
    SAVE_PREVIOUS_FILTERS: "SAVE_PREVIOUS_FILTERS",
    FLOOR_VIEW_REQUEST: "ASSET_FLOOR_VIEW_REQUEST",
    FLOOR_VIEW_SUCCESS: "ASSET_FLOOR_VIEW_SUCCESS",
    FLOOR_VIEW_FAILURE: "ASSET_FLOOR_VIEW_FAILURE",
};

export const fetchRequest = (id) => ({
    type: assetTypes.FETCH_REQUEST,
    payload: id
});

export const fetchSuccess = (resp) => ({
    type: assetTypes.FETCH_SUCCESS,
    payload: resp
});

export const fetchAllAssetsForMapSuccess = (payload) => ({
    type: assetTypes.FETCH_ALL_ASSETS_FOR_MAP_SUCCESS,
    payload,
});

export const savePreviousFilters = (filters) => ({
    type: assetTypes.SAVE_PREVIOUS_FILTERS,
    payload: filters,
});

export const fetchFailure = (resp) => ({
    type: assetTypes.FETCH_FAILURE,
    payload: resp
});

export const fetchDeviceTypesRequest = () => ({
    type: assetTypes.FETCH_DEVICE_TYPES_REQUEST
});
export const fetchSingleDeviceTypesRequest = (deviceType) => ({
    type: assetTypes.FETCH_SINGLE_DEVICE_TYPES_REQUEST,
    payload: deviceType
});

export const fetchLocationAlertsRequest = (options) => ({
    type: assetTypes.FETCH_LOCATION_ALERTS_REQUEST,
    payload: options
});

export const fetchLocationAlertsResponse = (resp) => ({
    type: assetTypes.FETCH_LOCATION_ALERTS_RESPONSE,
    payload: resp
});

export const fetchDeviceTypesSuccess = (resp) => ({
    type: assetTypes.FETCH_DEVICE_TYPES_SUCCESS,
    payload: resp
});

export const fetchDeviceTypesFailure = (resp) => ({
    type: assetTypes.FETCH_DEVICE_TYPES_FAILURE,
    payload: resp
});
export const fetchSingleDeviceTypesSuccess = (resp) => ({
    type: assetTypes.FETCH_SINGLE_DEVICE_TYPES_SUCCESS,
    payload: resp
});

export const fetchSingleDeviceTypesFailure = (resp) => ({
    type: assetTypes.FETCH_SINGLE_DEVICE_TYPES_FAILURE,
    payload: resp
});

export const fetchDeviceNamesRequest = () => ({
    type: assetTypes.FETCH_DEVICE_NAMES_REQUEST
});

export const fetchDeviceNamesSuccess = (resp) => ({
    type: assetTypes.FETCH_DEVICE_NAMES_SUCCESS,
    payload: resp
});

export const fetchDeviceNamesFailure = (resp) => ({
    type: assetTypes.FETCH_DEVICE_NAMES_FAILURE,
    payload: resp
});

export const fetchDeviceProfilesRequest = (deviceType) => ({
    type: assetTypes.FETCH_DEVICE_PROFILES_REQUEST,
    payload: deviceType
});

export const fetchDeviceProfilesSuccess = (resp) => ({
    type: assetTypes.FETCH_DEVICE_PROFILES_SUCCESS,
    payload: resp
});

export const fetchDeviceProfilesFailure = (resp) => ({
    type: assetTypes.FETCH_DEVICE_PROFILES_FAILURE,
    payload: resp
});

export const fetchLocationsRequest = () => ({
    type: assetTypes.FETCH_LOCATIONS_REQUEST
});

export const fetchLocationsSuccess = (resp) => ({
    type: assetTypes.FETCH_LOCATIONS_SUCCESS,
    payload: resp
});

export const fetchLocationsFailure = (resp) => ({
    type: assetTypes.FETCH_LOCATIONS_FAILURE,
    payload: resp
});

export const fetchDeviceCountFromGatewayRequest = (gatewayId) => ({
    type: assetTypes.FETCH_DEVICE_COUNT_FROM_GATEWAY_REQUEST,
    payload: gatewayId
});

export const fetchDeviceCountFromGatewaySuccess = (resp) => ({
    type: assetTypes.FETCH_DEVICE_COUNT_FROM_GATEWAY_SUCCESS,
    payload: resp
});

export const fetchDeviceCountFromGatewayFailure = (resp) => ({
    type: assetTypes.FETCH_DEVICE_COUNT_FROM_GATEWAY_FAILURE,
    payload: resp
});

export const updateFilters = (resp) => ({
    type: assetTypes.UPDATE_FILTERS,
    payload: resp
});

export const clearFilter = () => ({
    type: assetTypes.CLEAR_FILTER,
});

export const updatePageNo = (payload) => ({
    type: assetTypes.UPDATE_PAGE_NO,
    payload: payload
});

export const updateUI = (payload) => {
    return {
        type: assetTypes.UPDATE_UI,
        payload: payload
    };
};

export const createRequest = () => ({
    type: assetTypes.CREATE_REQUEST
});

export const createSuccess = (resp) => ({
    type: assetTypes.CREATE_SUCCESS,
    payload: resp
});

export const createFailure = (error) => ({
    type: assetTypes.CREATE_FAILURE,
    payload: error
});

export const updateRequest = () => ({
    type: assetTypes.UPDATE_REQUEST
});

export const updateSuccess = (resp) => ({
    type: assetTypes.UPDATE_SUCCESS,
    payload: resp
});

export const updateFailure = (error) => ({
    type: assetTypes.UPDATE_FAILURE,
    payload: error
});

export const downloadRequest = (req, filterList) => ({
    type: assetTypes.DOWNLOAD_REQUEST,
    payload: req,
    filter: filterList
});

export const downloadSuccess = (resp) => ({
    type: assetTypes.DOWNLOAD_SUCCESS,
    payload: resp
});

export const downloadFailure = (error) => ({
    type: assetTypes.DOWNLOAD_FAILURE,
    payload: error
});

export const deleteRequest = () => ({
    type: assetTypes.DELETE_REQUEST
});

export const deleteSuccess = (resp) => ({
    type: assetTypes.DELETE_SUCCESS,
    payload: resp
});

export const deleteFailure = (resp) => ({
    type: assetTypes.DELETE_FAILURE,
    payload: resp
});

export const downloadImageRequest = (imageId) => ({
    type: assetTypes.DOWNLOAD_IMAGE_REQUEST,
    payload: imageId
});

export const downloadImageSuccess = (resp) => ({
    type: assetTypes.DOWNLOAD_IMAGE_SUCCESS,
    payload: resp
});

export const downloadImageFailure = (error) => ({
    type: assetTypes.DOWNLOAD_IMAGE_FAILURE,
    payload: error
});

export const fetchDeviceDetailsRequest = () => ({
    type: assetTypes.FETCH_DEVICE_DETAILS_REQUEST,
});

export const fetchDeviceDetailsSuccess = (resp) => ({
    type: assetTypes.FETCH_DEVICE_DETAILS_SUCCESS,
    payload: resp
});

export const fetchDeviceDetailsFailure = (error) => ({
    type: assetTypes.FETCH_DEVICE_DETAILS_FAILURE,
    payload: error
});

export const floorViewRequest = (floorId) => ({
    type: assetTypes.FLOOR_VIEW_REQUEST,
    payload: floorId
});

export const floorViewSuccess = (resp) => ({
    type: assetTypes.FLOOR_VIEW_SUCCESS,
    payload: resp
});

export const floorViewFailure = (error) => ({
    type: assetTypes.FLOOR_VIEW_FAILURE,
    payload: error
});